// extracted by mini-css-extract-plugin
export var planCard = "_v8-0";
export var planList = "_v8-1";